export class SuperAdministrateur {

    nom: string = "";
    prenom: string = "";
    telephone: string = "";
    token: string = "";
    email: string = "";
    user_reference: string = "";
    pays_id: any;
    ville_id: any;
    sexe: any;
    admin_id: any;
    private errorMessage: string;
  
    constructor() {
      this.errorMessage = "";
    }
  
    // Récupérer le message d'erreur
    getErrorMessage(): string {
      return this.errorMessage;
    } // fin de getErrorMessage
  
    // Vérifier si on peut sauvegarder
    canSave(): boolean {
  
      // Vérification du nom
      if (!this.nom || this.nom.trim() === "") {
        this.errorMessage = "Veuillez saisir le nom de l'administrateur";
        return false;
      }
  
      // Vérification du prénom
      if (!this.prenom || this.prenom.trim() === "") {
        this.errorMessage = "Veuillez saisir le prénom de l'administrateur";
        return false;
      }
  
      // Vérification du téléphone
      if (!this.telephone || this.telephone.trim() === "") {
        this.errorMessage = "Veuillez saisir le numéro de téléphone de l'administrateur";
        return false;
      } else if (!/^\d+$/.test(this.telephone)) { // Vérification que le téléphone contient uniquement des chiffres
        this.errorMessage = "Le numéro de téléphone doit contenir uniquement des chiffres";
        return false;
      }
  
      // Vérification de l'email
      if (!this.email || this.email.trim() === "") {
        this.errorMessage = "Veuillez saisir l'adresse email de l'administrateur";
        return false;
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) { // Format de l'email
        this.errorMessage = "Veuillez saisir une adresse email valide";
        return false;
      }
  
      if (!this.sexe ) {
        this.errorMessage = "Veuillez sélectionner le sexe";
        return false;
      }
  
    //   if (!this.situation_matrimoniale ) {
    //     this.errorMessage = "Veuillez sélectionner la sitution matrimoniale";
    //     return false;
    //   }
  
      if (!this.pays_id ) {
        this.errorMessage = "Veuillez sélectionner le pays";
        return false;
      }
  
      if (!this.ville_id ) {
        this.errorMessage = "Veuillez sélectionner la ville";
        return false;
      }
      //  
      // if (!this.arrondisement_id ) {
      //   this.errorMessage = "Veuillez sélectionner l'arrondissement";
      //   return false;
      // }
  
      // Vérification de l'ID de la coopérative
      // if (!this.cooperative_id) {
      //   this.errorMessage = "Veuillez sélectionner une  coopérative";
      //   return false;
      // }
  
      // Si tous les champs sont valides
      this.errorMessage = ""; // Réinitialiser le message d'erreur
      return true;
  
    } // fin de canSave
  
  }
  